import React from "react";
import styles from "../../Common/Styles/master.module.css";
import Button from "../../Common/Button/button";
import Filters from "../../Common/Filters/filters";
import TableActions from "../../Common/TableActions/tableactions";
import {
  PageHeader,
  Input,
  Row,
  Col,
  Select,
  Form,
  Space,
  Popconfirm,
  Table,
  Modal,
  notification,
  Tooltip,
  Spin,
  DatePicker,
  Tabs,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faPencilAlt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DeliveryDashboardService from "../../../services/deliverydashboard.service";
import { IsAuthenticated } from "../../../services/auth-header";
import UserRightsConfiguration from "../../../shared/userrightsconfiguration";
import Common from "../../../services/common";
import { labels } from "../../../shared/language";
import moment from "moment";
import jwt from "jsonwebtoken";
const { Option } = Select;
const ONE_MONTHS_AGO = new Date();
ONE_MONTHS_AGO.setMonth(ONE_MONTHS_AGO.getMonth() - 1);

export default class deliverydashboard extends React.Component {
  constructor(props) {
    super(props);
    this.UserRightsConfiguration = new UserRightsConfiguration();
    this.DeliveryDashboardService = new DeliveryDashboardService();
    this.common = new Common();
    this.state = {
      selectedBranch: localStorage.getItem("branchID"),
      orderFromDate: moment(ONE_MONTHS_AGO),
      orderToDate: moment(),
      selectedDeliverytype: "1",
      modalLoading: false,
      dashboardItems: [],
      detailItems: [],
      deliveryTypes: [],
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
      },
      paginationforDetailtable: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
      },
      rowselectedvalue: "",
      showfilterBox: true,
      showAddPopup: false,
      loading: true,
      userRights: [],
      isResponseErrorShow: false,
      attention: {},
      overdueItems: [],
      overduePagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true },
      stageAging: [],
      dispatchSla: {},
      dispatchSlaHours: 48,
      dispatchSlaLoaded: false,
      tatSummary: {},
      tatItems: [],
      tatPagination: { current: 1, pageSize: 25, total: 0, showSizeChanger: true },
      tatLevel: "",
      tatLoading: false,
      tatAckRow: null,
      tatAckType: "",
      tatAckRemark: "",
      tatAckDate: "",
      tatAckSaving: false,
      tatInfoOpen: false,
      tatConfig: null,
      tatConfigLoading: false,
      dispatchSlaLoading: false,
    };
  }

  //   componentWillMount() {
  //     if (!IsAuthenticated()) {
  //       window.location.href = "/";
  //     }

  //     var data = JSON.parse(localStorage.getItem("userrights"));
  //     var res = data.filter(
  //       (val) => val.screenName == this.UserRightsConfiguration.CITY_MASTER
  //     );

  //     const storeOrFactory = localStorage
  //       .getItem("Store/FactoryType")
  //       .toLowerCase();
  //     if (!res[0].isView) {
  //       if (storeOrFactory === "store") {
  //         window.location.href = "/store/dashboard";
  //       } else {
  //         window.location.href = "/factory/dashboard";
  //       }
  //     }
  //     this.setState({ userRights: res });
  //   }

  columns = [
    {
      title: "Store Name",
      dataIndex: "shortName",
      key: "shortName",
    },

    {
      title: "Factory In",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInFactoryIn",
          key: "walkInFactoryIn",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "6",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandFactoryIn",
          key: "onDemandFactoryIn",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "6",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },

    {
      title: "Store In Pending",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInStoreInPending",
          key: "walkInStoreInPending",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "7",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandStoreInPending",
          key: "onDemandStoreInPending",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "7",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },

    {
      title: "Partial Order",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInPartialOrder",
          key: "walkInPartialOrder",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "8",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandPartialOrder",
          key: "onDemandPartialOrder",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "8",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },

    {
      title: "Ready to Deliver",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInReadytoDeliver",
          key: "walkInReadytoDeliver",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "9,10,11",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandReadytoDeliver",
          key: "onDemandReadytoDeliver",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "9,10,11",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },

    {
      title: "Paid and Undeliverd",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInPaidandUndeliverd",
          key: "walkInPaidandUndeliverd",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "15",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandPaidandUndeliverd",
          key: "onDemandPaidandUndeliverd",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "15",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },

    {
      title: "Total",
      children: [
        {
          title: "Walk In",
          dataIndex: "walkInTotal",
          key: "walkInTotal",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "6,7,8,9,10,11,15",
                    "WalkIn",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
        {
          title: "On Demand",
          dataIndex: "onDemandTotal",
          key: "onDemandTotal",
          render: (text, record) => (
            <Space size="middle">
              <Button
                type="link"
                onClick={() =>
                  this.getSplitOrderStatusWiseData(
                    "6,7,8,9,10,11,15",
                    "OnDemand",
                    record.storeID
                  )
                }
              >
                {text}
              </Button>
            </Space>
          ),
        },
      ],
    },
  ];

  Detailcolumns = [
    {
      title: "Store Name",
      dataIndex: "shortName",
      key: "shortName",
      //   width: '40%',
    },
    {
      title: "SplitOrder Number",
      dataIndex: "splitOrderNumber",
      key: "splitOrderNumber",
      //   width: '40%',
    },
    {
      title: "SplitOrder Status",
      dataIndex: "splitOrderStatusName",
      key: "splitOrderStatusName",
      //   width: '40%',
    },
    {
      title: "Delivery Date",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      //   width: '40%',
      render: (text) => {
        return ![undefined, null, ""].includes(text)
          ? moment(text).format("DD/MM/YYYY")
          : "";
      },
    },
    {
      title: "Delivery Type",
      dataIndex: "deliveryType",
      key: "deliveryType",
      //   width: '40%',
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
      //   width: '40%',
    },
  ];

  OverdueColumns = [
    { title: "SplitOrder", dataIndex: "splitOrderNumber", key: "splitOrderNumber" },
    { title: "Store", dataIndex: "shortName", key: "shortName" },
    { title: "Stage", dataIndex: "stage", key: "stage" },
    {
      title: "Held by", dataIndex: "custody", key: "custody",
      render: (t) => {
        const c = t && t.indexOf("factory") >= 0 ? "#2563eb" : "#c67f00";
        return (<span style={{ color: c, fontWeight: 600 }}>{t}</span>);
      },
    },
    { title: "Delivery Date", dataIndex: "deliveryDate", key: "deliveryDate" },
    {
      title: "Days Late", dataIndex: "daysLate", key: "daysLate",
      render: (t) => (<span style={{ color: t > 7 ? "#e5484d" : "#c67f00", fontWeight: 600 }}>{t}d</span>),
    },
    { title: "Order Type", dataIndex: "orderType", key: "orderType" },
    {
      title: "\u20b9 at risk", dataIndex: "amountAtRisk", key: "amountAtRisk",
      render: (t) => "\u20b9" + Math.round(t || 0).toLocaleString("en-IN"),
    },
  ];

  TatLevelColors = { BREACHED: "#b01e24", IMMINENT: "#e5484d", AT_RISK: "#c67f00", WATCH: "#2563eb", OK: "#3aa76d", STALE: "#6b7280", PAYMENT: "#7c3aed" };

  TatColumns = [
    { title: "SplitOrder", dataIndex: "splitOrderNumber", key: "splitOrderNumber" },
    { title: "Store", dataIndex: "storeName", key: "storeName" },
    {
      title: "Risk", dataIndex: "riskLevel", key: "riskLevel",
      render: (t) => (<span style={{ color: this.TatLevelColors[t] || "#333", fontWeight: 700, fontSize: 12 }}>{(t || "").replace("_", " ")}</span>),
    },
    { title: "Stage", dataIndex: "stage", key: "stage" },
    {
      title: "Held by", dataIndex: "custody", key: "custody",
      render: (t) => {
        const s = (t || "").toLowerCase();
        let c = "#c67f00"; // store (amber)
        if (s.indexOf("transit") >= 0) c = "#7c3aed";        // in transit (purple)
        else if (s.indexOf("factory") >= 0) c = "#2563eb";   // factory (blue)
        return (<span style={{ color: c, fontWeight: 600 }}>{t}</span>);
      },
    },
    { title: "Promised", dataIndex: "deliveryDate", key: "deliveryDate" },
    {
      title: "In stage", dataIndex: "hoursInStage", key: "hoursInStage",
      render: (t) => (t >= 48 ? Math.round(t / 24) + "d" : (t || 0) + "h"),
    },
    {
      title: "Why", dataIndex: "riskReasons", key: "riskReasons",
      render: (t) => (
        <span>
          {(t || "").split(",").filter(Boolean).map((r) => (
            <span key={r} style={{ display: "inline-block", background: "#f0f0f0", borderRadius: 4, padding: "0 6px", marginRight: 4, marginBottom: 2, fontSize: 11 }}>{r.replace(/_/g, " ")}</span>
          ))}
        </span>
      ),
    },
    { title: "Revised ETA", dataIndex: "revisedEta", key: "revisedEta" },
    {
      title: "\u20b9 at risk", dataIndex: "amountAtRisk", key: "amountAtRisk",
      render: (t) => "\u20b9" + Math.round(t || 0).toLocaleString("en-IN"),
    },
    {
      title: "Ops status", key: "ack",
      render: (_, r) => r.ackType ? (
        <Tooltip title={(r.ackRemark || "") + (r.ackActionDate ? " | action by " + r.ackActionDate : "") + " | " + (r.ackOn || "")}>
          <a onClick={() => this.openTatAck(r, r.ackType)} style={{ color: r.ackType === "WILL_RECOVER" ? "#3aa76d" : "#e5484d", fontWeight: 600, fontSize: 12 }}>
            {r.ackType === "WILL_RECOVER" ? "Will recover" : "Can't recover"}
          </a>
          <div style={{ fontSize: 11, color: "#999" }}>{r.ackByName}</div>
        </Tooltip>
      ) : (
        <Space>
          <a style={{ fontSize: 12 }} onClick={() => this.openTatAck(r, "WILL_RECOVER")}>Will recover</a>
          <a style={{ fontSize: 12, color: "#e5484d" }} onClick={() => this.openTatAck(r, "CANT_RECOVER")}>Can't</a>
        </Space>
      ),
    },
  ];

  fetchTatData = () => {
    this.setState({ tatLoading: true });
    const storeId = this.state.selectedBranch;
    this.DeliveryDashboardService.getTATRiskSummary({ StoreId: storeId }).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({ tatSummary: res.data && res.data.length > 0 ? res.data[0] : {} });
      }
    });
    const tp = this.state.tatPagination;
    this.DeliveryDashboardService.getTATRiskList({
      StoreId: storeId,
      Level: this.state.tatLevel,
      pageIndex: tp.current,
      pageSize: tp.pageSize,
    }).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({
          tatItems: res.data || [],
          tatLoading: false,
          tatPagination: { ...tp, total: res.data && res.data.length > 0 ? res.data[0].totalRecords : 0 },
        });
      } else {
        this.setState({ tatLoading: false });
      }
    });
  };

  handleTatTableChange = (pagination) => {
    this.setState({ tatPagination: pagination }, this.fetchTatData);
  };

  handleTatLevelChange = (v) => {
    this.setState(
      { tatLevel: v || "", tatPagination: { ...this.state.tatPagination, current: 1 } },
      this.fetchTatData
    );
  };

  openTatAck = (row, type) => {
    this.setState({ tatAckRow: row, tatAckType: type, tatAckRemark: row.ackRemark || "", tatAckDate: "" });
  };

  openTatInfo = () => {
    this.setState({ tatInfoOpen: true });
    if (!this.state.tatConfig) {
      this.setState({ tatConfigLoading: true });
      this.DeliveryDashboardService.getTATConfig({}).then((res) => {
        this.setState({
          tatConfig: res && res.statusCode === 200 && res.data && res.data.length > 0 ? res.data[0] : {},
          tatConfigLoading: false,
        });
      });
    }
  };

  renderTatMethodology = () => {
    const cfg = this.state.tatConfig || {};
    const pol = {};
    (cfg.policy || []).forEach((p) => { pol[p.policyKey] = p.policyValue; });
    const stageLabel = {
      DISPATCH: "Billed → Store out (dispatch)",
      TO_FACTORY: "Store out → Factory in (transit)",
      FACTORY_PROC: "Factory in → Factory out (processing)",
      TO_STORE: "Factory out → Store in (return)",
      DELIVERY: "Store in → Delivered (last mile)",
      TOTAL: "Billed → Delivered (end-to-end)",
    };
    const stages = (cfg.stages || []).filter((s) => stageLabel[s.stage]);
    const h = (v) => (v == null ? "—" : (v >= 48 ? (Math.round(v / 24 * 10) / 10) + "d" : Math.round(v) + "h"));
    const sec = { marginBottom: 18 };
    const hd = { fontWeight: 600, fontSize: 14, margin: "0 0 6px" };
    const p = { fontSize: 13, color: "#444", margin: "0 0 6px", lineHeight: 1.5 };
    const th = { textAlign: "left", fontSize: 11, textTransform: "uppercase", letterSpacing: ".4px", color: "#888", padding: "6px 10px", borderBottom: "1px solid #eee" };
    const td = { fontSize: 13, padding: "6px 10px", borderBottom: "1px solid #f2f2f2", verticalAlign: "top" };
    const pill = (c, t) => (<span style={{ color: c, fontWeight: 700, fontSize: 12 }}>{t}</span>);
    const dot = (c) => ({ display: "inline-block", width: 9, height: 9, background: c, borderRadius: 2, marginRight: 6 });

    if (this.state.tatConfigLoading) return (<div style={{ padding: 20 }}><Spin /> Loading current settings…</div>);

    return (
      <div style={{ maxHeight: "68vh", overflowY: "auto", paddingRight: 6 }}>
        <div style={sec}>
          <p style={p}>
            This tab scans every active order and flags the ones likely to <b>miss their promised delivery date — before it happens</b>,
            so the team can act while there's still time. It re-scores automatically every 20 minutes.
            It is read-only: it never changes an order, only highlights risk.
          </p>
        </div>

        <div style={sec}>
          <div style={hd}>Risk levels</div>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead><tr><th style={th}>Level</th><th style={th}>Meaning</th><th style={th}>Flagged when</th></tr></thead>
            <tbody>
              <tr><td style={td}>{pill("#b01e24", "BREACHED")}</td><td style={td}>Already past the promised date</td><td style={td}>Promised date &lt; today</td></tr>
              <tr><td style={td}>{pill("#e5484d", "IMMINENT")}</td><td style={td}>Due now, not yet ready</td><td style={td}>Due within {pol.IMMINENT_HORIZON_DAYS || 1} day and still at store / in transit / at factory</td></tr>
              <tr><td style={td}>{pill("#c67f00", "AT RISK")}</td><td style={td}>Stuck longer than normal, or breaking dispatch SLA</td><td style={td}>In a stage past its p90 time, or over the dispatch SLA, or rescheduled ≥2×</td></tr>
              <tr><td style={td}>{pill("#2563eb", "WATCH")}</td><td style={td}>Worth keeping an eye on</td><td style={td}>Due within {pol.WATCH_HORIZON_DAYS || 2} days, or rescheduled once</td></tr>
            </tbody>
          </table>
          <p style={{ ...p, marginTop: 6, color: "#888", fontSize: 12 }}>
            Orders older than {pol.STALE_DAYS || 90} days (Stale) and payment-pending orders are tracked separately and never raise an alert.
          </p>
        </div>

        <div style={sec}>
          <div style={hd}>Who's holding it ("Held by")</div>
          <p style={p}>
            <span style={dot("#c67f00")} /><b>Store – not dispatched:</b> billed, still at the store, not yet sent out.{" "}
            <span style={{ ...dot("#7c3aed"), marginLeft: 10 }} /><b>In transit – factory not received:</b> store has dispatched it; factory hasn't scanned it in yet.{" "}
            <span style={{ ...dot("#2563eb"), marginLeft: 10 }} /><b>At factory:</b> received, being processed.{" "}
            <span style={{ ...dot("#c67f00"), marginLeft: 10 }} /><b>Store – not delivered:</b> back at the store, not yet handed to the customer.
          </p>
        </div>

        <div style={sec}>
          <div style={hd}>Current dispatch SLA — store → factory (per delivery type)</div>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead><tr><th style={th}>Delivery type</th><th style={th}>Must dispatch within</th></tr></thead>
            <tbody>
              <tr><td style={td}>Express</td><td style={td}><b>{pol.DISPATCH_SLA_HOURS_DT3 || 12} h</b></td></tr>
              <tr><td style={td}>Semi&nbsp;Express</td><td style={td}><b>{pol.DISPATCH_SLA_HOURS_DT2 || 24} h</b></td></tr>
              <tr><td style={td}>Normal</td><td style={td}><b>{pol.DISPATCH_SLA_HOURS_DT1 || 48} h</b></td></tr>
            </tbody>
          </table>
        </div>

        <div style={sec}>
          <div style={hd}>Learned stage times (from the last 90 days of completed orders)</div>
          <p style={{ ...p, fontSize: 12, color: "#888" }}>
            "Stuck" is judged against the p90 (slowest 10%) for each stage — not a guess. Revised ETA uses the p80. These recompute daily.
          </p>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead><tr><th style={th}>Stage</th><th style={th}>Typical (p50)</th><th style={th}>p80</th><th style={th}>Slow (p90)</th></tr></thead>
            <tbody>
              {stages.map((s) => (
                <tr key={s.stage}>
                  <td style={td}>{stageLabel[s.stage]}</td>
                  <td style={td}>{h(s.p50Hours)}</td>
                  <td style={td}>{h(s.p80Hours)}</td>
                  <td style={td}>{h(s.p90Hours)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ ...sec, background: "#f6f8fa", border: "1px solid #e6ebf0", borderRadius: 6, padding: "10px 12px" }}>
          <div style={{ ...hd, marginBottom: 4 }}>Reviewing this?</div>
          <p style={{ ...p, margin: 0 }}>
            These SLAs and thresholds are our starting assumptions — tell us what to change (e.g. a different dispatch SLA, or a tighter "imminent" window)
            and we'll re-tune and re-score against real orders. Snapshot last scored: <b>{cfg.lastScored || "—"}</b>{cfg.totalScored ? " · " + cfg.totalScored.toLocaleString("en-IN") + " orders scored" : ""}.
          </p>
        </div>
      </div>
    );
  };

  saveTatAck = () => {
    const row = this.state.tatAckRow;
    if (!row) return;
    let userId = 0;
    let userName = "";
    try {
      const decoded = jwt.decode(JSON.parse(localStorage.getItem("currentuser")).token);
      userId = parseInt(decoded.unique_name) || 0;
      userName = decoded.name || decoded.given_name || ("User " + userId);
    } catch (e) { /* keep defaults */ }
    this.setState({ tatAckSaving: true });
    this.DeliveryDashboardService.saveTATRiskAck({
      SplitOrderNumber: row.splitOrderNumber,
      AckType: this.state.tatAckType,
      AckBy: userId,
      AckByName: userName,
      Remark: this.state.tatAckRemark,
      ActionDate: this.state.tatAckDate,
    }).then((res) => {
      const ok = res && res.statusCode === 200 && res.data && res.data.length > 0 && res.data[0].success === 1;
      notification[ok ? "success" : "error"]({
        message: "At Risk",
        description: ok ? "Saved" : (res && res.data && res.data.length > 0 && res.data[0].msg ? res.data[0].msg : "Unable to save"),
      });
      this.setState({ tatAckRow: null, tatAckSaving: false }, this.fetchTatData);
    });
  };

  fetchAuxData = () => {
    const base = {
      DeliveryType: this.state.selectedDeliverytype,
      FromOrderDate: this.state.orderFromDate,
      ToOrderDate: this.state.orderToDate,
      StoreId: this.state.selectedBranch,
    };
    this.DeliveryDashboardService.getDeliveryAttention(base).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({ attention: res.data && res.data.length > 0 ? res.data[0] : {} });
      }
    });
    const op = this.state.overduePagination;
    this.DeliveryDashboardService.getDeliveryOverdueList({
      ...base, pageIndex: op.current, pageSize: op.pageSize,
    }).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({
          overdueItems: res.data,
          overduePagination: { ...op, total: res.data.length > 0 ? res.data[0].totalRecords : 0 },
        });
      }
    });
    this.DeliveryDashboardService.getDeliveryStageAging(base).then((res) => {
      if (res && res.statusCode === 200) { this.setState({ stageAging: res.data || [] }); }
    });
    this.fetchTatData();
    // dispatch-SLA is intentionally NOT auto-loaded: it is a ~2s garment-join query.
    // It loads on demand via fetchDispatchSla() so the landing stays light.
  };

  // dispatch SLA (hours) per delivery type: 3=Express 12h, 2=Semi-Express 24h, 1=Normal 48h
  dispatchSlaForType = (dt) => {
    const map = { "1": 48, "2": 24, "3": 12 };
    return map[String(dt)] || 48;
  };

  // on-demand heavy query (garment join) — triggered by the "Show dispatch performance" button
  fetchDispatchSla = () => {
    const slaHours = this.dispatchSlaForType(this.state.selectedDeliverytype);
    this.setState({ dispatchSlaLoading: true });
    this.DeliveryDashboardService.getDeliveryDispatchSLA({
      DeliveryType: this.state.selectedDeliverytype,
      FromOrderDate: this.state.orderFromDate,
      ToOrderDate: this.state.orderToDate,
      StoreId: this.state.selectedBranch,
      SlaHours: slaHours,
    }).then((res) => {
      if (res && res.statusCode === 200) {
        this.setState({
          dispatchSla: res.data && res.data.length > 0 ? res.data[0] : {},
          dispatchSlaHours: slaHours,
          dispatchSlaLoaded: true,
          dispatchSlaLoading: false,
        });
      } else {
        this.setState({ dispatchSlaLoading: false });
      }
    });
  };

  handleOverdueTableChange = (pagination) => {
    this.setState({ overduePagination: pagination }, () => {
      this.DeliveryDashboardService.getDeliveryOverdueList({
        DeliveryType: this.state.selectedDeliverytype,
        FromOrderDate: this.state.orderFromDate,
        ToOrderDate: this.state.orderToDate,
        StoreId: this.state.selectedBranch,
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
      }).then((res) => {
        if (res && res.statusCode === 200) {
          this.setState({
            overdueItems: res.data,
            overduePagination: { ...pagination, total: res.data.length > 0 ? res.data[0].totalRecords : 0 },
          });
        }
      });
    });
  };

  componentDidMount() {
    const { pagination } = this.state;
    this.setState({ isResponseErrorShow: false });
    this.fetchItems({
      DeliveryType: this.state.selectedDeliverytype,
      FromOrderDate: this.state.orderFromDate,
      ToOrderDate: this.state.orderToDate,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      // StoreID:parseInt(this.state.selectedBranch),
      StoreID:this.state.selectedBranch,
      pagination,
    });
    this.getDeliveryTypes();
  }

  getDeliveryTypes = () => {
    this.DeliveryDashboardService.getDeliveryTypeList().then((response) => {
      if (response.statusCode === 200) {
        this.setState({
          deliveryTypes: response.data,
        });
      } else {
        notification["error"]({
          message: labels.PICKUPS,
          description: labels.UNABLE_TO_GET_DATA_FOR_DELIVERY_TYPES,
        });
      }
    });
  };

  fetchItems = (params = {}) => {
    this.setState({ loading: true });
    this.fetchAuxData();
    this.DeliveryDashboardService.retrieveItems(params).then((items) => {
      if (items.statusCode === 200) {
        if (
          items.length !== 0 &&
          items.data.length === 0 &&
          params.pagination.current !== 1
        ) {
          params.pagination.current = 1;
          this.fetchItems({
            DeliveryType: this.state.selectedDeliverytype,
            FromOrderDate: this.state.orderFromDate,
            ToOrderDate: this.state.orderToDate,
            // StoreID:parseInt(this.state.selectedBranch),
            StoreID:this.state.selectedBranch,
            pageIndex: 1,
            pageSize: params.pageSize,
            pagination: params.pagination,
          });
        }
        this.setState({
          dashboardItems: items.data,
          pagination: {
            ...params.pagination,
            total: items.data.length > 0 ? items.data[0].totalRecords : 0,
          },
        });
      } else {
        if (!this.state.isResponseErrorShow) {
          notification["error"]({
            message: "Delivery Dashboard",
            description: items.message
              ? items.message
              : "Unable to get Delivery Dashboard data",
          });
          this.setState({
            isResponseErrorShow: true,
          });
        }
      }
      this.setState({ loading: false });
    });
  };

  getSplitOrderStatusWiseData = (status, type, storeId) => {
    // this.setState({detailItems:[]})
    let params = {
      SplitOrderStatus: status,
      OrderType: type,
      DeliveryType: this.state.selectedDeliverytype,
      StoreID: storeId,
      FromOrderDate: this.state.orderFromDate,
      ToOrderDate: this.state.orderToDate,
    };
    this.setState({ modalLoading: true });
    this.DeliveryDashboardService.getDeliveryDatafromSplitOrderStatus(
      params
    ).then((items) => {
      if (items.statusCode === 200) {
        if (
          items.length !== 0 &&
          items.data.length === 0 &&
          params.pagination.current !== 1
        ) {
          params.pagination.current = 1;
          this.fetchItems({
            DeliveryType: this.state.selectedDeliverytype,
            FromOrderDate: this.state.orderFromDate,
            ToOrderDate: this.state.orderToDate,
            StoreID:this.state.selectedBranch,
            // StoreID:parseInt(this.state.selectedBranch),
            pageIndex: 1,
            pageSize: params.pageSize,
            pagination: params.pagination,
          });
        }

        this.setState({
          detailItems: items.data,
          showAddPopup: true,
          paginationforDetailtable: {
            ...params.pagination,
            total: items.data.length > 0 ? items.data[0].totalRecords : 0,
          },
          // isRenderComponent: true,
        });
      } else {
        if (!this.state.isResponseErrorShow) {
          notification["error"]({
            message: "Delivery Dashboard",
            description: items.message
              ? items.message
              : "Unable to get Delivery Dashboard data",
          });
          this.setState({
            isResponseErrorShow: true,
          });
        }
      }
      this.setState({ modalLoading: false });
    });
  };

  handleTableChange = (pagination) => {
    this.fetchItems({
      DeliveryType: this.state.selectedDeliverytype,
      FromOrderDate: this.state.orderFromDate,
      ToOrderDate: this.state.orderToDate,
      // StoreID:parseInt(this.state.selectedBranch),
      StoreID:this.state.selectedBranch,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      pagination,
    });
  };

  // handleTableChangeforDetailData = (pagination) => {
  //   this.fetchItems({
  //     DeliveryType: this.state.selectedDeliverytype,
  //     FromOrderDate: this.state.orderFromDate,
  //     ToOrderDate: this.state.orderToDate,
  //     pageIndex: pagination.current,
  //     pageSize: pagination.pageSize,
  //     pagination,
  //   });
  // };

  // handleChangeBranch = () => {
  //   this.fetchItems({
  //     DeliveryType: this.state.selectedDeliverytype,
  //     FromOrderDate: this.state.orderFromDate,
  //     ToOrderDate: this.state.orderToDate,
  //     StoreID:parseInt(this.state.selectedBranch),
  //     pageIndex:this.state.pagination.current,
  //     pageSize:this.state.pagination.pageSize,
  //     // this.state.pagination,
  //   });
  // };

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  };

  handlePopupCancel = () => {
    this.setState({ showAddPopup: false });
  };

  render() {
    const storeBranchTypes = ![undefined, null, ""].includes(
      localStorage.getItem("BranchInfo")
    )
      ? JSON.parse(localStorage.getItem("BranchInfo")).filter(
          (x) => x.branchType === "Store"
        )
      : [];

    const allStoreBranchArray = storeBranchTypes
      .map((branchType) => {
        return branchType.branchID;
      })
      .filter((x) => x !== "-1")
      .slice()
      .sort();
    const { paginationforDetailtable, pagination, loading } = this.state;
    const dashboardItems = this.state.dashboardItems;
    const listItems = dashboardItems.map((item, index) => ({
      key: item.storeID,
      storeID: item.storeID,
      storeName: item.storeName,
      shortName: item.shortName,
      walkInFactoryIn: item.walkInFactoryIn,
      onDemandFactoryIn: item.onDemandFactoryIn,
      walkInStoreInPending: item.walkInStoreInPending,
      onDemandStoreInPending: item.onDemandStoreInPending,
      walkInPartialOrder: item.walkInPartialOrder,
      onDemandPartialOrder: item.onDemandPartialOrder,
      walkInReadytoDeliver: item.walkInReadytoDeliver,
      onDemandReadytoDeliver: item.onDemandReadytoDeliver,
      walkInPaidandUndeliverd: item.walkInPaidandUndeliverd,
      onDemandPaidandUndeliverd: item.onDemandPaidandUndeliverd,
      walkInTotal: item.walkInTotal,
      onDemandTotal: item.onDemandTotal,
      totalRecords: item.totalRecords,
    }));
    const detailItems = this.state.detailItems;
    const DetailListItem = detailItems.map((item) => ({
      // key: item.storeID,
      storeName: item.storeName,
      shortName: item.shortName,
      splitOrderNumber: item.splitOrderNumber,
      splitOrderStatusName: item.splitOrderStatusName,
      deliveryDate: item.deliveryDate,
      deliveryType: item.deliveryType,
      orderType: item.orderType,
    }));
    const att = this.state.attention || {};
    const OverdueListItems = (this.state.overdueItems || []).map((it, i) => ({ key: (it.splitOrderNumber || "") + i, ...it }));
    const tat = this.state.tatSummary || {};
    const tatActionable = (tat.breached || 0) + (tat.imminent || 0) + (tat.atRisk || 0);
    const TatListItems = (this.state.tatItems || []).map((it, i) => ({ key: (it.splitOrderNumber || "") + i, ...it }));
    const attCard = (c) => ({ border: "1px solid #eee", borderLeft: "3px solid " + c, borderRadius: 8, padding: "8px 12px" });
    const attNum = (c) => ({ fontSize: 22, fontWeight: 700, color: c, lineHeight: 1 });
    const attLbl = { fontSize: 12, color: "#6b6b6b", marginTop: 4 };
    const attAmt = { fontSize: 12, color: "#555", marginTop: 2, fontWeight: 600 };
    const money = (v) => "\u20b9" + Math.round(v || 0).toLocaleString("en-IN");
    const dot = (c) => ({ display: "inline-block", width: 9, height: 9, background: c, borderRadius: 2, marginRight: 4 });
    const sortedStages = (this.state.stageAging || []).slice().sort((a, b) => (b.total || 0) - (a.total || 0));
    const maxStageTotal = Math.max.apply(null, [1].concat((this.state.stageAging || []).map((x) => x.total || 0)));
    const factorySide = att.factoryDelay || 0;
    const storeSide = (att.storeDispatchDelay || 0) + (att.storeDeliveryDelay || 0);
    const custTotal = factorySide + storeSide;
    const storePct = custTotal ? Math.round((storeSide / custTotal) * 100) : 0;
    const dsla = this.state.dispatchSla || {};
    const dslaLatePct = (dsla.dispatchedTotal || 0) > 0 ? Math.round(((dsla.dispatchedLate || 0) / dsla.dispatchedTotal) * 100) : 0;
    return (
      <div>
        <PageHeader
          title="Delivery Dashboard"
          extra={[
            <Button
              type="link"
              className={styles.FilterToggle}
              onClick={() => {
                this.setState({ showfilterBox: !this.state.showfilterBox });
              }}
            >
              {this.state.showfilterBox ? "Hide Filters" : "Show Filters"}
              <FontAwesomeIcon
                icon={faChevronUp}
                className={
                  this.state.showfilterBox
                    ? styles.FilterToggleIcon
                    : styles.FilterToggleIconRotated
                }
              />
            </Button>,
          ]}
        />
        <Filters show={this.state.showfilterBox}>
          <Form
            onFinish={() =>
              this.fetchItems({
                DeliveryType: this.state.selectedDeliverytype,
                FromOrderDate: this.state.orderFromDate,
                ToOrderDate: this.state.orderToDate,
                // StoreID:parseInt(this.state.selectedBranch),
                StoreID:this.state.selectedBranch,
                pageIndex: pagination.current,
                pageSize: pagination.pageSize,
                pagination,
              })
            }
            initialValues={{
              orderFromDate: this.state.orderFromDate,
              orderToDate: this.state.orderToDate,
              DeliveryType: this.state.selectedDeliverytype,
              storeId:this.state.selectedBranch
            }}
          >
            <Row gutter={24}>
              <Col xs={24} lg={6}>
                <Form.Item name="DeliveryType">
                  <Select
                    allowClear
                    placeholder={labels.DELIVERY_TYPE}
                    style={{ minWidth: 150, maxWidth: 250 }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value) =>
                      this.setState(
                        {
                          selectedDeliverytype: [null, undefined, ""].includes(
                            value
                          )
                            ? undefined
                            : value,
                        },
                        () => {
                          // console.log(this.state.deliveryTypes.selectedDeliverytype);
                        }
                      )
                    }
                  >
                    {this.state.deliveryTypes.map((x) => {
                      return x.value != "-1" ? (
                        <option
                          key={x.value.toString()}
                          value={x.value.toString()}
                        >
                          {x.text}
                        </option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} lg={4}>
                <Form.Item
                  name={"orderFromDate"}
                  rules={[
                    { required: true, message: labels.PLEASE_SELECT_FROM_DATE },
                  ]}
                >
                  <DatePicker
                    placeholder={labels.FROM_DATE}
                    format={"DD-MM-YYYY"}
                    onChange={(date) =>
                      this.handleDateChange(date, "orderFromDate")
                    }
                    value={this.state.orderFromDate}
                    disabledDate={(currentDate) =>
                      currentDate.isAfter(moment(), "day") ? true : false
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={4}>
                <Form.Item
                  name={"orderToDate"}
                  rules={[
                    { required: true, message: labels.PLEASE_SELECT_TO_DATE },
                  ]}
                >
                  <DatePicker
                    placeholder={labels.TO_DATE}
                    format={"DD-MM-YYYY"}
                    onChange={(date) =>
                      this.handleDateChange(date, "orderToDate")
                    }
                    value={this.state.orderToDate}
                    disabledDate={(currentDate) =>
                      currentDate.isAfter(moment(), "day") ? true : false
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item
                  name={"storeId"}
                  rules={[{ required: true, message: "Please select store " }]}
                >
                  <Select
                    showSearch 
                    mode="multiple"
                    allowClear
                    onChange={(event) => {
                      this.setState(
                        {
                          selectedBranch: [null, undefined, ""].includes(event)
                            ? ""
                            : event.join(","),
                        },
                        () => {
                          // this.handleChangeBranch();
                        }
                      );
                    }}
                    value={
                      [null, undefined, ""].includes(this.state.selectedBranch)
                        ? [localStorage.getItem("branchID")]
                        : this.state.selectedBranch.split(",")
                    }
                    // value={this.state.selectedBranch}
                    placeholder={labels.SELECT_STORE}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {storeBranchTypes.length !== 0
                      ? storeBranchTypes.map((branchType) => {
                          return branchType.branchID !== "-1" ? (
                            <Option
                              value={branchType.branchID.toString()}
                              key={branchType.branchID.toString()}
                            >
                              {branchType.branchName}
                            </Option>
                          ) : null;
                        })
                      : null}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} lg={4} className={styles.ActionContainer}>
                <Button
                  htmlType="submit"
                  variant="whitePink"
                  shape="round"
                  size="large"
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </Form>
        </Filters>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 10, marginBottom: 12, marginTop: 8 }}>
          <div style={attCard("#e5484d")}><div style={attNum("#e5484d")}>{att.overdue || 0}</div><div style={attLbl}>Overdue</div><div style={attAmt}>{money(att.overdueValue)}</div></div>
          <div style={attCard("#b01e24")}><div style={attNum("#b01e24")}>{att.critical7d || 0}</div><div style={attLbl}>Critical &gt;7 days</div><div style={attAmt}>{money(att.critical7dValue)}</div></div>
          <div style={attCard("#c67f00")}><div style={attNum("#c67f00")}>{att.dueToday || 0}</div><div style={attLbl}>Due today</div><div style={attAmt}>{money(att.dueTodayValue)}</div></div>
          <div style={attCard("#7c3aed")}><div style={attNum("#7c3aed")}>{att.paidUndelivered || 0}</div><div style={attLbl}>Paid &amp; undelivered</div><div style={attAmt}>{money(att.paidUndeliveredValue)}</div></div>
        </div>

        <div style={{ fontWeight: 600, marginBottom: 8 }}>Where the delay sits {"—"} who is holding overdue orders</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(185px,1fr))", gap: 10, marginBottom: 8 }}>
          <div style={attCard("#e5484d")}>
            <div style={attNum("#e5484d")}>{att.storeDispatchDelay || 0}</div>
            <div style={attLbl}>Store {"–"} not sent to factory</div>
            <div style={attAmt}>{money(att.storeDispatchDelayValue)}</div>
            <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>factory never received it</div>
          </div>
          <div style={attCard("#2563eb")}>
            <div style={attNum("#2563eb")}>{att.factoryDelay || 0}</div>
            <div style={attLbl}>At factory {"–"} not returned</div>
            <div style={attAmt}>{money(att.factoryDelayValue)}</div>
            <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>dispatched, awaiting return</div>
          </div>
          <div style={attCard("#c67f00")}>
            <div style={attNum("#c67f00")}>{att.storeDeliveryDelay || 0}</div>
            <div style={attLbl}>Store {"–"} not delivered</div>
            <div style={attAmt}>{money(att.storeDeliveryDelayValue)}</div>
            <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>back at store, not handed over</div>
          </div>
        </div>
        {custTotal > 0 ? (
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: "flex", height: 22, borderRadius: 4, overflow: "hidden", marginBottom: 4 }}>
              <div style={{ width: storePct + "%", background: "#c67f00", display: "flex", alignItems: "center", paddingLeft: 8, fontSize: 11, color: "#fff", whiteSpace: "nowrap" }}>{"Store " + storeSide + " (" + storePct + "%)"}</div>
              <div style={{ width: (100 - storePct) + "%", background: "#2563eb" }} />
            </div>
            <div style={{ fontSize: 11, color: "#666" }}>
              <span><span style={dot("#c67f00")} /> Store holds {storeSide}</span>
              <span style={{ marginLeft: 14 }}><span style={dot("#2563eb")} /> Factory holds {factorySide} ({custTotal ? Math.round((factorySide / custTotal) * 100) : 0}%)</span>
            </div>
          </div>
        ) : null}

        <div style={{ marginBottom: 16 }}>
          {!this.state.dispatchSlaLoaded ? (
            <div>
              <button onClick={this.fetchDispatchSla} disabled={this.state.dispatchSlaLoading}
                style={{ padding: "6px 14px", fontSize: 13, border: "1px solid #d0d0d0", borderRadius: 6, background: "#fafafa", cursor: this.state.dispatchSlaLoading ? "default" : "pointer", color: "#333" }}>
                {this.state.dispatchSlaLoading ? "Loading dispatch performance..." : "Show store dispatch performance"}
              </button>
              <span style={{ fontSize: 11, color: "#999", marginLeft: 10 }}>on-demand {"—"} how long the store held orders before sending to the factory</span>
            </div>
          ) : (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>Store dispatch performance {"—"} sent to factory within {this.state.dispatchSlaHours}h <span style={{ fontWeight: 400, color: "#888", fontSize: 12 }}>(SLA for this delivery type)</span></div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(185px,1fr))", gap: 10 }}>
                <div style={attCard("#e5484d")}>
                  <div style={attNum("#e5484d")}>{dsla.dispatchedLate || 0}</div>
                  <div style={attLbl}>Dispatched late ({dslaLatePct}%)</div>
                  <div style={attAmt}>{money(dsla.dispatchedLateValue)}</div>
                  <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>held too long before sending out</div>
                </div>
                <div style={attCard("#3aa76d")}>
                  <div style={attNum("#3aa76d")}>{dsla.dispatchedOnTime || 0}</div>
                  <div style={attLbl}>Dispatched on time</div>
                  <div style={attAmt}>of {dsla.dispatchedTotal || 0} dispatched</div>
                </div>
                <div style={attCard("#6b7280")}>
                  <div style={attNum("#6b7280")}>{Math.round(dsla.avgDispatchHours || 0)}h</div>
                  <div style={attLbl}>Avg time to dispatch</div>
                  <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>order created {"→"} sent to factory</div>
                </div>
              </div>
            </div>
          )}
        </div>

        {this.state.stageAging && this.state.stageAging.length > 0 ? (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Where the orders are {"\u2014"} and how late</div>
            {sortedStages.map((s) => {
              const w = (v) => ((v / maxStageTotal) * 100) + "%";
              const late = (s.late1to7 || 0) + (s.crit7plus || 0);
              return (
                <div key={s.stage} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <div style={{ width: 150, fontSize: 13 }}>{s.stage}</div>
                  <div style={{ flex: 1, display: "flex", height: 20, borderRadius: 4, overflow: "hidden", background: "#f0f0f0" }}>
                    <div style={{ width: w(s.onTime || 0), background: "#3aa76d" }} title={"on-time " + (s.onTime || 0)} />
                    <div style={{ width: w(s.late1to7 || 0), background: "#f5a623" }} title={"1-7d late " + (s.late1to7 || 0)} />
                    <div style={{ width: w(s.crit7plus || 0), background: "#e5484d" }} title={">7d " + (s.crit7plus || 0)} />
                  </div>
                  <div style={{ width: 180, textAlign: "right", fontSize: 12, color: "#666" }}><b style={{ color: "#222" }}>{s.total}</b> {"\u00b7"} <span style={{ color: "#e5484d" }}>{late} late</span> {"\u00b7"} {money(s.value)}</div>
                </div>
              );
            })}
            <div style={{ display: "flex", gap: 14, fontSize: 11, color: "#666", marginTop: 4 }}>
              <span><span style={dot("#3aa76d")} /> On-time</span>
              <span><span style={dot("#f5a623")} /> 1{"\u2013"}7 days late</span>
              <span><span style={dot("#e5484d")} /> &gt;7 days (critical)</span>
            </div>
          </div>
        ) : null}

        <Tabs defaultActiveKey="overview">
          <Tabs.TabPane tab="Overview" key="overview">
            <Table size="small" columns={this.columns} dataSource={listItems} pagination={pagination} loading={loading} onChange={this.handleTableChange} />
            <TableActions isPagination={true}></TableActions>
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Overdue / Action (" + (att.overdue || 0) + ")"} key="overdue">
            <Table size="small" columns={this.OverdueColumns} dataSource={OverdueListItems} pagination={this.state.overduePagination} loading={loading} onChange={this.handleOverdueTableChange} />
            <TableActions isPagination={true}></TableActions>
          </Tabs.TabPane>
          <Tabs.TabPane tab={"At Risk (" + tatActionable + ")"} key="atrisk">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontWeight: 600, fontSize: 15 }}>Proactive TAT Risk {"—"} pre-breach queue</div>
              <a onClick={this.openTatInfo} style={{ fontSize: 13, display: "inline-flex", alignItems: "center", gap: 5 }}>
                {/* plain styled glyph — a FontAwesome SVG here rendered unbounded (giant circle) on prod */}
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 15, height: 15, minWidth: 15, border: "1px solid currentColor", borderRadius: "50%", fontSize: 10, fontWeight: 700, fontStyle: "italic", lineHeight: 1, fontFamily: "Georgia, serif" }}>i</span>
                How this works {"—"} methodology &amp; current SLAs
              </a>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 10, marginBottom: 10 }}>
              <div style={attCard("#b01e24")}><div style={attNum("#b01e24")}>{tat.breached || 0}</div><div style={attLbl}>Breached</div><div style={attAmt}>{money(tat.breachedValue)}</div></div>
              <div style={attCard("#e5484d")}><div style={attNum("#e5484d")}>{tat.imminent || 0}</div><div style={attLbl}>Imminent {"—"} due {"≤"}1d, not ready</div><div style={attAmt}>{money(tat.imminentValue)}</div></div>
              <div style={attCard("#c67f00")}><div style={attNum("#c67f00")}>{tat.atRisk || 0}</div><div style={attLbl}>At risk {"—"} stuck / SLA</div><div style={attAmt}>{money(tat.atRiskValue)}</div></div>
              <div style={attCard("#2563eb")}><div style={attNum("#2563eb")}>{tat.watch || 0}</div><div style={attLbl}>Watch</div><div style={attAmt}>{money(tat.watchValue)}</div></div>
            </div>
            <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <Select allowClear placeholder="All actionable levels" style={{ width: 220 }} value={this.state.tatLevel || undefined} onChange={this.handleTatLevelChange}>
                <Option value="BREACHED">Breached</Option>
                <Option value="IMMINENT">Imminent</Option>
                <Option value="AT_RISK">At risk</Option>
                <Option value="WATCH">Watch</Option>
                <Option value="OK">On track</Option>
                <Option value="STALE">Stale (&gt;90d)</Option>
                <Option value="PAYMENT">Payment pending</Option>
              </Select>
              <span style={{ fontSize: 11, color: "#999" }}>auto-scored every 20 min {"·"} last scored: {tat.computedOn || "-"} {"·"} pre-breach view: catch it BEFORE the promised date slips</span>
            </div>
            <Table size="small" columns={this.TatColumns} dataSource={TatListItems} pagination={this.state.tatPagination} loading={this.state.tatLoading} onChange={this.handleTatTableChange} />
            <TableActions isPagination={true}></TableActions>
          </Tabs.TabPane>
        </Tabs>

        <Modal
          title={(this.state.tatAckType === "WILL_RECOVER" ? "Will recover {—} plan" : "Can't recover {—} reason").replace("{—}", "—")}
          visible={this.state.tatAckRow !== null}
          onCancel={() => this.setState({ tatAckRow: null })}
          onOk={this.saveTatAck}
          okText="Save"
          confirmLoading={this.state.tatAckSaving}
          destroyOnClose
        >
          <div style={{ marginBottom: 8, fontWeight: 600 }}>{this.state.tatAckRow ? this.state.tatAckRow.splitOrderNumber + " · " + (this.state.tatAckRow.stage || "") : ""}</div>
          <Input.TextArea
            rows={3}
            placeholder={this.state.tatAckType === "WILL_RECOVER" ? "What will be done to recover this order?" : "Why can this not be recovered in time?"}
            value={this.state.tatAckRemark}
            onChange={(e) => this.setState({ tatAckRemark: e.target.value })}
          />
          {this.state.tatAckType === "WILL_RECOVER" ? (
            <div style={{ marginTop: 10 }}>
              <span style={{ fontSize: 12, color: "#666", marginRight: 8 }}>Action by:</span>
              <DatePicker onChange={(d, ds) => this.setState({ tatAckDate: ds })} />
            </div>
          ) : null}
        </Modal>

        <Modal
          title="Proactive TAT Risk — how it works"
          visible={this.state.tatInfoOpen}
          onCancel={() => this.setState({ tatInfoOpen: false })}
          footer={null}
          width={780}
        >
          {this.renderTatMethodology()}
        </Modal>

        <Modal
          title={"Delivery Dashboard"}
          visible={this.state.showAddPopup}
          footer={null}
          onCancel={this.handlePopupCancel}
          className="modal-form"
          destroyOnClose
          width={"50%"}
        >
          <Spin spinning={this.state.modalLoading}>
            <Table
              size="small"
              columns={this.Detailcolumns}
              dataSource={DetailListItem}
              loading={loading}
              pagination={paginationforDetailtable}
              //   onChange={this.handleTableChange}
              // onChange={this.handleTableChangeforDetailData}
            />
            <TableActions isPagination={true}></TableActions>
            <Row>
              <Col xs={24} className="custom-modal-footer">
                <Space>
                  <>
                    <Button
                      variant="transparentGreyOutline"
                      onClick={this.handlePopupCancel}
                    >
                      Close
                    </Button>
                  </>
                </Space>
              </Col>
            </Row>
          </Spin>
        </Modal>
      </div>
    );
  }
}
